import script from "./Time.vue?vue&type=script&lang=ts"
export * from "./Time.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__